<template>
  <v-card width="100%" height="100%" id="videoPlayerCard">
    <v-card-title class="headline black--text" :style="backgroundStarStyle">
      <span>Video tutorials</span>
      <v-spacer></v-spacer>
      <v-btn icon light small class="m-0" @click="closePlayer()">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>
    <v-col>
      <v-row no-gutters>
        <v-col cols="4">
          <v-card class="mx-2">
            <v-toolbar class="elevation-2" :style="backgroundStarStyle" light>
              <v-toolbar-title>Library</v-toolbar-title>
              <v-spacer></v-spacer>
              <img
                :src="require('../../assets/images/flag-united-kingdom.png')"
                alt="EN"
                width="40"
                height="28"
                class="pa-1 ma-1"
                :style="
                  currentLanguage === 'EN'
                    ? 'cursor: pointer; background-color: #5757FF;'
                    : 'cursor: pointer;'
                "
                @click="setLanguage('EN')"
              />
              <img
                :src="require('../../assets/images/flag-france.png')"
                alt="FR"
                width="40"
                height="28"
                class="pa-1 ma-1"
                :style="
                  currentLanguage === 'FR'
                    ? 'cursor: pointer; background-color: #5757FF;'
                    : 'cursor: pointer;'
                "
                @click="setLanguage('FR')"
              />
            </v-toolbar>

            <v-container
              fluid
              grid-list-lg
              class="px-3"
              :style="'max-height: ' + cardHeight + 'px; overflow-y: scroll'"
            >
              <v-row>
                <exo-form-alert class="ml-2" type="info"
                  >space<b>studio</b>™ was named ExoOPS - <i>Mission Design</i>™ in the past. The videos may refers to this legacy name.
                </exo-form-alert>
                <exo-form-alert class="ml-2" type="info"
                  >Some modules were renamed after the version 2.2. The
                  "Simulations" module was called "Numerical" and the
                  "Parametric Studies" module was called "Anaytical". Some
                  videos may refer to the old names.</exo-form-alert
                >
                <exo-form-alert
                  class="ml-2"
                  type="grey"
                  v-if="currentLanguage === 'FR'"
                  >Only a few videos are translated into french, please check
                  the english versions to access all tutorials.</exo-form-alert
                >
                <v-col
                  cols="12"
                  v-for="(video, index) in videoList"
                  :key="index"
                  @click="videoClicked(index)"
                >
                  <v-hover>
                    <v-card
                      :color="cardBackground(index)"
                      slot-scope="{ hover }"
                      :class="`elevation-${hover ? 5 : 2}`"
                    >
                      <v-row>
                        <v-col cols="5">
                          <v-img
                            :src="
                              require('../../assets/images/videos_thumbnails/' +
                                video.label +
                                '.png')
                            "
                            :alt="`${video.label} thumbnail`"
                            height="125px"
                            contain
                          ></v-img>
                        </v-col>
                        <v-col cols="7">
                          <h6>{{ video.label }}</h6>
                          <v-spacer></v-spacer>
                          <!-- TODO align duration bottom + grey -->
                          <div>{{ video.duration }}</div>
                        </v-col>
                      </v-row>
                      <v-divider light></v-divider>
                    </v-card>
                  </v-hover>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
        <v-col grey lighten-3 pa-2 cols="8">
          <iframe
            v-if="currentVideo !== null"
            title="vimeo-player"
            :src="currentVideoUrl"
            width="100%"
            height="100%"
            frameborder="0"
            allowfullscreen
          ></iframe>
        </v-col>
      </v-row>
    </v-col>
  </v-card>
</template>

<script>
import videoLibrary from './VideoLibrary.json'

export default {
  name: 'tutorialVideoPlayer',

  data() {
    return {
      library: videoLibrary,
      currentLanguage: 'EN',
      currentVideoIndex: 0,
      urlPrefix: 'https://player.vimeo.com/video/',
      cardHeight: 600
    }
  },

  computed: {
    backgroundStarStyle() {
      return (
        'background: #3BE287'
      )
    },

    videoList: function () {
      if (this.library && this.library.length && this.currentLanguage !== '') {
        return this.library.filter(
          (video) => video.language === this.currentLanguage
        )
      }
      return []
    },

    currentVideoUrl: function () {
      if (!this.currentVideo) {
        return ''
      }
      return this.urlPrefix + this.currentVideo.fileId
    },

    currentVideo: function () {
      if (this.currentVideoIndex >= 0 && this.videoList.length) {
        return this.videoList[this.currentVideoIndex]
      }
      return null
    }
  },

  methods: {
    cardBackground(index) {
      if (this.$vuetify.theme.dark === false) {
        if (index === this.currentVideoIndex) {
          return 'blue lighten-4'
        } else {
          return 'grey lighten-4'
        }
      } else {
        if (index === this.currentVideoIndex) {
          return 'grey darken-3'
        } else {
          return ''
        }
      }
    },

    closePlayer() {
      this.$emit('playerClosed')
    },

    videoClicked(video) {
      this.currentVideoIndex = video
    },

    setLanguage(language) {
      this.currentLanguage = language
      if (!this.library || !this.library.length || language === '') {
        return
      }
      let videoListLength = this.library.filter(
        (video) => video.language === language
      ).length
      if (!videoListLength) {
        this.currentVideoIndex = -1
      } else if (this.currentVideoIndex >= videoListLength) {
        this.currentVideoIndex = 0
      }
    }
  }
}

// <video controls>
//   <source :src="demoVideoUrl">
// </video>
</script>
